import { useEffect, type ReactNode } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';
import * as urls from 'routes/config';
import Spinner from '@/components/Common/Spinner';

const { base: ONBOARDING_BASE, stage1 } = urls.businessOnboarding;

type ProtectedStageProps = { children: ReactNode };

export default function ProtectedStage({ children }: ProtectedStageProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const authToken = Cookies.get('auth_token');
  const isStage2 = location.pathname.includes('/stage-2');
  const isSuccessReturn = searchParams.get('success') === 'true';
  const hasQuery = location.search.length > 0 || isSuccessReturn;
  const needsRedirect = !authToken && isStage2 && !hasQuery;

  useEffect(() => {
    if (needsRedirect) {
      navigate(`${ONBOARDING_BASE}/${stage1()}`, { replace: true });
    }
  }, [needsRedirect, navigate]);

  if (needsRedirect) {
    return <Spinner />;
  }

  return <>{children}</>;
}
